import React from 'react'
import { NavLink } from 'react-router-dom'
import RegisterConfirmComponent from './RegisterConfirmComponent'
import LoginRegisterHeader from '../../components/HeaderLoginRegister'
import LoginRegisterHeaderRwd from '../../components/HeaderLoginRegisterRwd'
import LoginRegisterLogo from '../../components/LogoLoginRegister'
import { useTranslation } from 'react-i18next'

const Register = () => {
  const { t } = useTranslation();

  return (
    <>
      <LoginRegisterHeader>
        <NavLink to="/">{ t('Back to Investhub') }</NavLink>
      </LoginRegisterHeader>

      <LoginRegisterHeaderRwd>
        <div className="actions__option actions__option_normal d__block">
          <NavLink to="/">{ t('Back to Investhub') }</NavLink>
        </div>
      </LoginRegisterHeaderRwd>

      <div className="entry entry_loginregister">
        <div className="entry__wrapper entry__wrapper-kyc">
          <LoginRegisterLogo />

          <RegisterConfirmComponent />
        </div>
      </div>
    </>
  );
};

export default Register;
